<template>
    <div :class="`progress-bar bg-${progressBarType}`"
         role="progressbar"
         :style="{width: scorePercentage + '%'}"
         :aria-valuenow="scorePercentage"
         aria-valuemin="0"
         aria-valuemax="100"
    ><span v-if="showText">{{ score }} {{ progressBarType }} answers</span>
    </div>
</template>

<script>
    export default {
        props: {
            score: {
                type: Number,
                required: true,
            },
            totalScore: {
                type: Number,
                required: true,
            },
            progressBarType: {
                type: String,
                required: true,
            },
            showText: {
                type: Boolean,
                required: false,
                default: true,
            }
        },
        computed: {
            scorePercentage() {
                if (this.totalScore === 0) {
                    return 0;
                }
                return Math.round((this.score * 100)/this.totalScore);
            }
        }
    }
</script>

<style scoped lang="scss">
    .bg-correct {
        background-color: #11b748 !important;
    }
    .bg-wrong {
        background-color: #FF4E4E !important;
    }
    .progress-bar {
        min-height: 10px;
        border-radius: 5px;
    }
</style>
